import { all, fork, takeEvery, takeLeading } from 'redux-saga/effects';
import { sliceName } from '../redux/dashboardSlice';
import * as Sagas from './saga';

function* watchFetchStats() {
    yield takeLeading(`${sliceName}/fetchStats`, Sagas.fetchStatsSaga);
}

function* watchFetchNotifications() {
    yield takeLeading(
        `${sliceName}/fetchNotifications`,
        Sagas.fetchNotificationsSaga
    );
}

function* watchUpdateNotificationsRead() {
    yield takeEvery(
        `${sliceName}/updateNotificationsRead`,
        Sagas.updateNotificationsReadSaga
    );
}

function* watchFetchAssignments() {
    yield takeLeading(
        `${sliceName}/fetchAssignments`,
        Sagas.fetchAssignmentsSaga
    );
}

function* watchUpdateAssignment() {
    yield takeEvery(
        `${sliceName}/updateAssignment`,
        Sagas.updateAssignmentSaga
    );
}

function* watchCreateAssignment() {
    yield takeEvery(
        `${sliceName}/createAssignment`,
        Sagas.createAssignmentSaga
    );
}

function* watchDeleteAssignment() {
    yield takeEvery(
        `${sliceName}/deleteAssignment`,
        Sagas.deleteAssignmentSaga
    );
}

function* watchFetchTrackableStatistics() {
    yield takeLeading(
        `${sliceName}/fetchTrackableStatistics`,
        Sagas.fetchTrackableStatisticsSaga
    );
}
export function* dashboardSagas() {
    yield all([
        fork(watchFetchStats),
        fork(watchFetchNotifications),
        fork(watchUpdateNotificationsRead),
        fork(watchFetchAssignments),
        fork(watchUpdateAssignment),
        fork(watchCreateAssignment),
        fork(watchDeleteAssignment),
        fork(watchFetchTrackableStatistics),
    ]);
}
